"use strict";

/* Base choice — Oats | Black barley on every product card.
   One flavour = one product with two variants; the card renders in the
   default base (oats) and this script swaps it live:
     - picker buttons (card + quick-view panel share one state per card),
     - the calorie figure ([data-base-cal]),
     - the price element's data-onetime/data-sub pair,
     - every variant-id carrier on the card (stepper input, hidden form
       input, price-span carrier), so add-to-box and the optimistic cart
       engine act on the chosen base.
   After each swap it dispatches 'gr:base-changed' — gr-purchase-mode.js
   re-mirrors stepper counts / in-cart state from its local cart picture
   and re-derives session-contextual prices. No network calls here, ever.

   The choice is strictly PER CARD (owner decision 2026-08-04): picking
   Barley on Vanilla changes Vanilla and nothing else — every other flavour
   stays on its own selection, defaulting to Oats. */
document.addEventListener('DOMContentLoaded', () => {
  const BASES = ['oats', 'barley'];

  const applyToCard = (card, base) => {
    if (card.getAttribute('data-base-current') === base) return;
    card.setAttribute('data-base-current', base);
    const vid = card.getAttribute('data-base-' + base + '-id');

    /* Picker buttons — the card's own and, when open for this card, the
       quick-view panel's clone (both live under elements that reference
       the card, so scope by closest card OR panel adoption below). */
    card.querySelectorAll('[data-base-picker] [data-base-option]').forEach(btn => {
      const on = btn.getAttribute('data-base-option') === base;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    /* Calories. */
    const cal = card.getAttribute('data-base-' + base + '-cal');
    if (cal) {
      card.querySelectorAll('[data-base-cal]').forEach(el => { el.textContent = cal; });
    }

    /* Price pair — server-rendered per base; reconcileCardPrices() (via the
       gr:base-changed listener) immediately overrides with session-context
       prices when it has them and repaints the visible text. */
    const onetime = card.getAttribute('data-base-' + base + '-onetime');
    const sub = card.getAttribute('data-base-' + base + '-sub');
    card.querySelectorAll('[data-card-price]').forEach(el => {
      if (onetime) el.dataset.onetimePrice = onetime;
      if (sub) el.dataset.subPrice = sub; else delete el.dataset.subPrice;
      el.textContent = sub || onetime || el.textContent;
    });

    /* Variant-id carriers. */
    card.querySelectorAll('[data-card-variant-id]').forEach(el => {
      el.setAttribute('data-card-variant-id', vid);
    });
    card.querySelectorAll('input.product-variant-id, form[action*="/cart/add"] input[name="id"]').forEach(el => {
      el.value = vid;
    });

    card.dispatchEvent(new CustomEvent('gr:base-changed', {
      bubbles: true,
      detail: { card: card, base: base, variantId: vid },
    }));
  };

  /* One delegated listener serves the grid, the home preview row and the
     quick-view panel (whose picker is adopted to the origin card). Only the
     clicked card changes — nothing else. */
  document.addEventListener('click', event => {
    const btn = event.target.closest('[data-base-option]');
    if (!btn) return;
    const base = btn.getAttribute('data-base-option');
    if (BASES.indexOf(base) === -1) return;

    /* Inside the quick-view shell the picker belongs to the origin card. */
    const shell = btn.closest('[data-gr-qv]');
    const card = shell
      ? (window.grQuickViewOriginCard || null)
      : btn.closest('[data-base-oats-id]');
    if (!card) return;

    applyToCard(card, base);
    if (shell && window.grQuickViewAdopt) window.grQuickViewAdopt();
  });

  /* Public hook for the quick-view script (panel open → mirror card state). */
  window.grApplyCardBase = applyToCard;
  window.grCurrentBaseOf = card => card.getAttribute('data-base-current') || 'oats';
});
